import React from "react";

export default function VendorInfo({
  name,
  description,
  rating,
  logoUrl,
  totalReviews,
}) {
  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 mt-6">
      <div className="flex items-center gap-4">
        <div className="w-[90px] h-[90px] rounded-full border overflow-hidden bg-gray-100">
          <img
            src={logoUrl || "/images/vendor-logo.png"}
            className="w-full h-full object-contain"
            alt={name}
            onError={(e) => {
              e.target.src = "/images/vendor-logo.png";
            }}
          />
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-900">{name}</h3>
          <p className="text-gray-600 mt-1 text-sm">{description}</p>
          <div className="flex items-center gap-2 mt-1">
            <p className="text-yellow-500 font-medium">
              {" "}
              {"★".repeat(Math.ceil(rating))} {Math.ceil(rating)}
            </p>
            {/* {totalReviews && (
              <span className="text-gray-500 text-sm">
                ({totalReviews} reviews)
              </span>
            )} */}
          </div>
        </div>
      </div>
    </div>
  );
}
